define('views/modules/member/group/group-lists-controller',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // collections
    'collections/member/profiles',
    'collections/member/supervisors',
    // services
    'services/user',
    'services/events/user-events',
    // views
    'views/modules/member/group/lists/group-list',
    'views/parts/alert/alert-no-data',
    // templates
    'text!templates/modules/member/group/group-lists-controller.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // collections
    CGroups,
    Supervisors,
    // services
    User,
    UserEvents,
    // views
    VGroupList,
    VAlertNoData,
    // templates
    TGroupListsController
) {

    /**
     * Controls the 3 lists of member
     */
    var VGroupListsController = Backbone.View.extend({
        template: TGroupListsController,
        regions: {
            list: "#group-list",
            alert: ".empty-list-alert"
        },

        initialize: function(opt) {
            opt = opt || {};

            this.collection = opt.collection;

            var view = this.view = {
                    list: new VGroupList({
                        icon: "sl-icon-people",
                        collection: opt.collection
                    }),
                    alert: new VAlertNoData({
                        subtitle: 'Click on + to add a new group',
                        collection: this.collection,
                        caret: false
                    })
                };

            this.listenTo(this.collection, { 'group:click': this.onGroupClick });
            this.listenTo(this.collection, { 'remove': this.onGroupRemove });
            this.listenTo(UserEvents, { 'group:editGroup': this.unselect });

        },

        render: function() {
            this.collection.fetch();
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.list, zone.$list)
                .assign(view.alert, zone.$alert);

            return this;
        },

        unselect: function() {
            this.$('.item-section.active').removeClass('active');
        },
        ////////////
        // events //
        ////////////
        onGroupClick: function(groupModel) {
            this.unselect();
            this.trigger("group:click", groupModel, this.collection);
        },

        onGroupRemove: function(groupModel) {
            this.trigger("group:remove", groupModel, this.collection);
        },

    });

    return VGroupListsController;

});

